import React from "react";
import Dashhead from "../UserDashboard/Dashhead";
import SideBar from "./SideBar";

const UpdateMatchScore = () => {
  return (
    <div>
      <Dashhead />
      <SideBar />
    </div>
  );
};

export default UpdateMatchScore;
